import ImageViewer from '@/components/image-viewer/index.vue';
export default {
  props: ['info'],
  data() {
    return {
      showDialog: false
    };
  },
  components: {
    ImageViewer
  },
  computed: {
    images() {
      const image = this.info && this.info.addons && this.info.addons.paymentVouche;
      if (image) {
        return image;
      }
      return [];
    }
  },

  created() {
  },

  methods: {

  }
};
